import createPlugin from './createPlugin'

import YouTubeRenderer from './Renderer/YouTubeRenderer'

const youtubePlugin = settings =>
    createPlugin({
        Renderer: YouTubeRenderer,
        ...settings,
    })

const youtube = youtubePlugin()
export default youtube

export { youtubePlugin, YouTubeRenderer }
